import React from 'react'
import { Link } from "react-router-dom";


const TrackOrder = () => {
    return (
        <>
            <section className="section-breadcrumb main-wrapper">
                <div className="breadcrumb-area">
                    <div className="container">
                        <div className="breadcrumb-wrapper">
                            <nav className="breadcrumb">
                                <Link className="breadcrumb-item" to="/">Home</Link>
                                <span className="breadcrumb-item active" aria-current="page">Track Order</span>
                            </nav>
                            <h1 className="breadcrumb-title">Track Order</h1>
                        </div>
                        <div className="breadcrumb-bg-block">
                            <img src="assets/images/breadcrumb-bg.jpg" alt="breadcrumb-bg" width={1920} height={448} className="img-cover" />
                            <img src="assets/images/breadcrumb-shape.png" alt="breadcrumb-shape" width={1033} height={448} />
                        </div>
                    </div>
                </div>
            </section>


            <section className="section-get-in-touch" style={{ marginTop: "-150px" }}>
                <div className="position-relative z-1">
                    <div className="section-space">
                        <div className="container">
                            <div className="row g-4 mt-5">
                                <div className="col-lg-12">
                                    <div className="get-touch-form-block is-bg-primary">
                                        <h3>Track Your Orders</h3>
                                        <form action="#" method="post">
                                            <div className="row g-3">
                                                <div className="col-xl-12">
                                                    <input type="text" placeholder="Enter Your AWB / Tracking Number" required />
                                                </div>
                                                <div className="col-12">
                                                    <div className="row g-2">

                                                        {/* <div className="col-12">
                                                            <div className=" form-check">
                                                                <input type="checkbox" className="form-check-input" id="get-in-touch-6" />
                                                                <label className="form-check-label" htmlFor="get-in-touch-6">Ocean
                                                                    Freight</label>
                                                            </div>
                                                        </div> */}

                                                        <div className="col-12">
                                                            <Link to="/">
                                                                <button type="submit" className="btn btn-secondary">
                                                                    Track Orders
                                                                    <span className="btn-icon">
                                                                        <span>
                                                                            <i className="fa-regular fa-arrow-right" />
                                                                        </span>
                                                                        <span>
                                                                            <i className="fa-regular fa-arrow-right" />
                                                                        </span>
                                                                    </span>
                                                                </button>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src="assets/images/abstract/arrow-abstract-img-1.svg" alt="arrow-abstract-img-1" width={45} height={116} className="arrow-abstract-1 animate-bottom-to-top" style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)', opacity: 1 }} />
                </div>
            </section>

        </>
    )
}

export default TrackOrder